<template>
  <div class="status-chart-container">
    <vue-apex-charts
      id="monitoring-chart"
      height="125"
      :options="chartOptions"
      type="bar"
      :series="healthStatusSeriesComputed"
    />
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  name: 'HealthcheckLogChart',
  components: {
    VueApexCharts,
  },
  computed: {
    healthcheckStats() {
      return this.$store.state.healthcheckLogs.healthcheckStats
    },
    chartOptions() {
      return {
        chart: {
          id: 'stacked-bar',
          group: 'healthchecks',
          stacked: true,
          stackType: '100%',
          fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif',
        },
        colors: ['#00e396', '#ff4560', '#ffab00', '#9eb4c1'],
        dataLabels: {
          enabled: false,
        },
        noData: {
          text: 'No data available',
          align: 'center',
          verticalAlign: 'middle',
          offsetX: 0,
          offsetY: 0,
        },
        legend: {
          show: false,
        },
        yaxis: {
          labels: {
            minWidth: '10px',
          },
          show: false,
        },
        xaxis: {
          type: 'category',
          hideOverlappingLabels: true,
          tickAmount: 6,
          labels: {
            minWidth: '10px',
            style: {
              fontSize: '12px',
            },
            offsetX: 15,
            rotate: 0,
          },
          tooltip: {
            enabled: false,
          },
          categories: this.returnLabels(),
        },
        tooltip: {
          y: {
            formatter(log) {
              return log === 100 ? 'true' : 'false'
            },
          },
          z: {
            formatter(value) {
              return `${value[0]} / ${value[1]} `
            },
            title: 'Total / Healthy: ',
          },
        },
        responsive: [
          {
            breakpoint: 769,
            options: {
              xaxis: {
                tickAmount: 3,
              },
            },
          },
          {
            breakpoint: 480,
            options: {
              xaxis: {
                tickAmount: 1,
              },
            },
          },
        ],
      }
    },
    healthStatusSeriesComputed() {
      return this.getHealthStatusSeries()
    },
  },
  methods: {
    getEmptyModel() {
      return {
        x: '',
        y: 0,
        z: [0, 0],
      }
    },
    getEmptyModelWithFilledBar() {
      return {
        x: 'No Data',
        y: 100,
        z: [0, 0],
      }
    },
    createSeries(name, model) {
      return {
        name,
        data: Array(60).fill(model),
      }
    },
    updateSeries(series, serieNo, index, data) {
      series.forEach((serie, i) => {
        if (i === serieNo) {
          serie.data[index] = data
        } else {
          serie.data[index] = this.getEmptyModel()
        }
      })
    },
    getHealthStatusSeries() {
      const series = [
        this.createSeries('Healthy', this.getEmptyModel()),
        this.createSeries('Unhealthy', this.getEmptyModel()),
        this.createSeries('Degraded', this.getEmptyModel()),
        this.createSeries('No Data', this.getEmptyModelWithFilledBar()),
      ]

      this.healthcheckStats.forEach((e, index) => {
        const difference = e.requests - e.healthyRequests
        const unhealthyThreshold = e.requests * 0.3
        const data = {
          x: `${this.timeSince(e.executedAt)} ago`,
          y: 100,
          z: [e.requests, e.healthyRequests],
        }

        if (e.requests > e.healthyRequests) {
          if (difference > unhealthyThreshold) {
            // PUSH UNHEALTHY
            this.updateSeries(series, 1, index, data)
          } else {
            // PUSH DEGRADED
            this.updateSeries(series, 2, index, data)
          }
        } else {
          // PUSH HEALTHY
          this.updateSeries(series, 0, index, data)
        }
      })

      series.forEach(serie => serie.data.reverse())

      return series
    },
    returnLabels() {
      const series = this.healthcheckStats.length > 0 ? Array(60).fill('No Data') : []
      this.healthcheckStats.forEach((e, index) => {
        series[index] = `${this.timeSince(e.executedAt)} ago`
      })

      return series.reverse()
    },
  },
}
</script>
